import Core from "./Variants/Core";

const Select = ({
  name,
  options,
  label,
  placeholder,
  alertType,
  alertMessage,
  prefix,
  required,
  disabled,
  size,
  ...rest
}) => {
  return (
    <Core
      name={name}
      options={options}
      label={label}
      placeholder={placeholder}
      alertType={alertType}
      alertMessage={alertMessage}
      prefix={prefix}
      required={required}
      size={size}
      disabled={disabled}
      {...rest}
    />
  );
};

export default Select;
